import { service } from '@maia/quotation';
import { useMutation } from '@tanstack/react-query';

type UseCreateClaimArgs = Parameters<typeof service.createNote>[0];
type UseCreateClaimParams = Parameters<typeof service.createNote>[1];

export function useCreateNote(
  guids: UseCreateClaimArgs,
  onSuccess?: () => void,
  onError?: () => void,
) {
  return useMutation({
    mutationFn: (args: UseCreateClaimParams) => service.createNote(guids, args),
    onSuccess,
    onError,
  });
}
